module.exports = __webpack_public_path__ + "static/media/viewed.ff5f39ff.svg";